import _styled from "styled-components";
const _excluded = ["column", "children", "disabled", "getColumnName"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import Checkbox from '@adsk/alloy-react-checkbox';
import theme from '@adsk/alloy-react-theme';
const defaultColumnName = column => column.id;
const ColumnOption = (_ref, ref) => {
  let {
      column,
      children,
      disabled,
      getColumnName = defaultColumnName
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledLabel, _extends({
    ref: ref
  }, props, {
    $_css: [theme.typography.bodyMedium, _objectSpread({
      display: 'flex',
      alignItems: 'center',
      padding: "10px ".concat(theme.spacing.L, "px"),
      paddingLeft: children ? theme.spacing.XS : theme.spacing.L
    }, disabled ? {
      color: theme.tokens.colors.text.inactive.value
    } : {
      cursor: 'pointer',
      ':hover': {
        backgroundColor: theme.tokens.colors.background.neutral.hover.value
      }
    })]
  }), children, column.getCanHide() && /*#__PURE__*/React.createElement(Checkbox, {
    checked: column.getIsVisible(),
    disabled: disabled,
    onChange: checked => column.toggleVisibility(!!checked),
    style: {
      marginRight: theme.spacing.S
    }
  }), /*#__PURE__*/React.createElement("span", null, getColumnName(column)));
};
export default /*#__PURE__*/React.forwardRef(ColumnOption);
var _StyledLabel = _styled("label").withConfig({
  displayName: "ColumnOption___StyledLabel",
  componentId: "sc-zxdvce-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=ColumnOption.js.map